import React from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Container } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';
import { SocialLinks } from 'volto-social-settings';
import { SubFooter } from 'volto-subfooter';
import { displayBanner } from 'volto-gdpr-privacy';

const messages = defineMessages({
  cookieSettings: {
    id: 'Cookie settings',
    defaultMessage: 'Cookie settings',
  },
});

const FooterSmall = () => {
  const intl = useIntl();
  const location = useLocation();
  const dispatch = useDispatch();

  return (
    <div className="iv--footer-small">
      <Container>
        <div className="iv--footer-social">
          <SocialLinks />
        </div>

        <SubFooter pathname={location.pathname}>
          <button
            className="item"
            onClick={(e) => {
              e.preventDefault();
              dispatch(displayBanner(true, true));
            }}
            title={intl.formatMessage(messages.cookieSettings)}
          >
            {intl.formatMessage(messages.cookieSettings)}
          </button>
        </SubFooter>
      </Container>
    </div>
  );
};

export default FooterSmall;
